/**
 * Tabs Section Web Component
 * - Accessible tabs with keyboard navigation
 * - Smooth fade animation on tab change
 */
class TabsSection extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
  }

  connectedCallback() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectTab(index);
      });

      tab.addEventListener('keydown', (e) => {
        this.handleKeydown(e, index);
      });
    });

    // Ensure first tab is selected if none are
    const selectedTab = this.querySelector('[aria-selected="true"]');
    if (!selectedTab && this.tabs.length > 0) {
      this.selectTab(0);
    }
  }

  selectTab(index) {
    // Deselect all tabs
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });

    // Hide all panels
    this.panels.forEach((panel) => {
      panel.setAttribute('aria-hidden', 'true');
    });

    // Select the clicked tab
    const selectedTab = this.tabs[index];
    const panelId = selectedTab.getAttribute('aria-controls');
    const selectedPanel = this.querySelector(`#${panelId}`);

    selectedTab.setAttribute('aria-selected', 'true');
    selectedTab.setAttribute('tabindex', '0');
    selectedTab.focus();

    if (selectedPanel) {
      selectedPanel.setAttribute('aria-hidden', 'false');
    }
  }

  handleKeydown(event, currentIndex) {
    let newIndex;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        newIndex = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
        this.selectTab(newIndex);
        break;
      case 'ArrowRight':
        event.preventDefault();
        newIndex = currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1;
        this.selectTab(newIndex);
        break;
      case 'Home':
        event.preventDefault();
        this.selectTab(0);
        break;
      case 'End':
        event.preventDefault();
        this.selectTab(this.tabs.length - 1);
        break;
    }
  }
}

customElements.define('tabs-section', TabsSection);
